import { useTranslation } from 'react-i18next';

/** 各 AI 工具页标题走 nav 文案，说明和按钮走 studioModule。 */
export function useStudioModuleText(navId) {
  const { t } = useTranslation('workbench');
  const title = t(`nav.${navId}.label`, { defaultValue: '' });
  const field = (name, fallback = '') => {
    const value = t(`studioModule.${navId}.${name}`, { defaultValue: '' });
    return value || fallback;
  };
  return { t, title, field };
}

/** 固定选项只改显示，value 仍用配置里的原值。 */
export function localizeStudioOptions(t, group, options) {
  return (options || []).map((option) => {
    const label = t(`studioChrome.opt.${group}.${option.value}`, { defaultValue: '' });
    return label ? { ...option, label } : option;
  });
}

/**
 * 选图/上传超限提示：保留原有校验语义（整批拒绝），只把提示文案本地化。
 * unit 需按 incoming 数量传入已复数化的单位（如 images / prints）。
 */
export function studioSourceLimitMessage(t, { incoming, current = 0, room = 0, cap = 0, unit = '' }) {
  if (!incoming) return t('studioToast.pickFile');
  if (room <= 0) return t('studioToast.limitReached', { max: cap, unit });
  if (current > 0) return t('studioToast.limitRemain', { incoming, room, cap });
  return t('studioToast.limitOver', { cap, incoming, unit });
}
